












import { computed, defineComponent } from "@vue/composition-api";

import { Item } from "@/tools/msa/models/item";
import { calculatePageNumbers } from "@/tools/msa/utils/export";

interface Props {
  items: Set<Item>;
}

export default defineComponent<Props>({
  name: "PageList",
  props: {
    items: { type: Set, required: true }
  },
  setup(props: Props) {
    const numbers = computed(() =>
      [...props.items]
        .flatMap(item =>
          calculatePageNumbers(item).map(page => ({ page, item }))
        )
        .filter(
          (a, index, array) => array.findIndex(b => b.page === a.page) === index
        )
        .sort((a, b) => a.page - b.page)
    );

    return { numbers };
  }
});
